import React from "react";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Rating.styled";
import { RatingInfo } from "./Rating.info";

export const Rating = () => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Styled.Root>
      <Styled.Rating>
        <Styled.Stars>
          {Array.from({ length: 5 }).map((_, index) => (
            <Styled.AdaptiveIcon key={index}>
              <Styled.Star />
            </Styled.AdaptiveIcon>
          ))}
        </Styled.Stars>
        <Styled.Score>
          {RatingInfo.current} / {RatingInfo.max}
        </Styled.Score>
      </Styled.Rating>
      <Styled.RatingAnotation>
        {translate("rating_description")}
      </Styled.RatingAnotation>
    </Styled.Root>
  );
};
